import Utils from '@/common/utils/utils';

const getChatAttachmentOrder = file => {
    const order = file?.fileInfo?.order;
    return Number.isInteger(order) ? order : Number.MAX_SAFE_INTEGER;
};

export const getChatAttachmentFiles = (attachFiles, uploadedFilesByPost) => {
    if (!Utils.isEmptyArray(uploadedFilesByPost)) {
        return uploadedFilesByPost;
    }
    if (Utils.isEmptyArray(attachFiles)) return [];
    return [...attachFiles].sort((a, b) => getChatAttachmentOrder(a) - getChatAttachmentOrder(b));
};

export const isChatImageAttachment = file => {
    return Utils.isImageFile(file?.fileInfo?.fileName || file?.fileData?.name);
};
